var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91749 3.40475C4.60239 1.37027 6.50951 0 8.65618 0H33.8246C35.8761 0 37.3224 2.01293 36.6679 3.95715L34.0825 11.6369C33.3976 13.6714 31.4905 15.0417 29.3438 15.0417H4.17536C2.12393 15.0417 0.67764 13.0287 1.33215 11.0845L3.91749 3.40475Z",
    fill: "url(#paint0_linear_6274_9115)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.789 3.59766L13.5464 11.0825H12.3403L9.66143 5.98418H9.60295L8.75141 11.0825H7.39551L8.63811 3.59766H9.85147L12.5267 8.69963H12.5962L13.4404 3.59766H14.789Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0238 11.0825L16.2664 3.59766H21.1345L20.9444 4.73427H17.4323L17.096 6.76629H20.356L20.166 7.90291H16.906L16.5697 9.94589H20.1112L19.9211 11.0825H15.0238Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8504 11.0825L21.9805 3.59766H23.4388L23.8773 9.098H23.9468L26.2968 3.59766H27.6234L28.157 9.10165H28.2228L30.4814 3.59766H31.9396L28.5846 11.0825H27.247L26.6257 5.83069H26.5672L24.188 11.0825H22.8504Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6274_9115",
    x1: 8.78302,
    y1: 2.86508,
    x2: 28.6842,
    y2: 12.6991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563697,
    stopColor: "#1ABF16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTag);
export default __webpack_public_path__ + "static/media/new_tag.af0ab497e302a16d93da7569c0f01aa6.svg";
export { ForwardRef as ReactComponent };